// src/utils/theme-manager.ts
type ThemeConfig = {
  primary: string
  secondary: string
  success: string
  warning: string
  danger: string
  info: string
}

const DEFAULT_THEME: ThemeConfig = {
  primary: '#0A1A2F',
  secondary: '#C5A47E',
  success: '#67C23A',
  warning: '#E6A23C',
  danger: '#F56C6C',
  info: '#909399'
}

class ThemeManager {
  private currentTheme: ThemeConfig

  constructor() {
    this.currentTheme = this.loadTheme()
    this.applyTheme()
  }

  private loadTheme(): ThemeConfig {
    const saved = localStorage.getItem('theme')
    return saved ? JSON.parse(saved) : DEFAULT_THEME
  }

  public updateTheme(newTheme: Partial<ThemeConfig>) {
    this.currentTheme = { ...this.currentTheme, ...newTheme }
    this.applyTheme()
    localStorage.setItem('theme', JSON.stringify(this.currentTheme))
  }

  private applyTheme() {
    const root = document.documentElement
    root.style.setProperty('--el-color-primary', this.currentTheme.primary)
    root.style.setProperty('--el-color-primary-light-3', this.lightenColor(this.currentTheme.primary, 0.3))
    root.style.setProperty('--el-color-secondary', this.currentTheme.secondary)
    root.style.setProperty('--el-color-success', this.currentTheme.success)
    root.style.setProperty('--el-color-warning', this.currentTheme.warning)
    root.style.setProperty('--el-color-danger', this.currentTheme.danger)
    root.style.setProperty('--el-color-info', this.currentTheme.info)
  }

  private lightenColor(hex: string, percent: number): string {
    const num = parseInt(hex.replace('#', ''), 16)
    const amt = Math.round(2.55 * percent * 100)
    const R = (num >> 16) + amt
    const G = (num >> 8 & 0x00FF) + amt
    const B = (num & 0x0000FF) + amt
    return `#${(1 << 24 | R << 16 | G << 8 | B).toString(16).slice(1)}`
  }

}

export const themeManager = new ThemeManager()